export default __webpack_public_path__ + "static/pub-a66889331d9a7cf7b951e2589970b0c0.jpg";